import { motion } from "framer-motion";

const EASE = [0.22, 1, 0.36, 1];

export const EventsHero = ({ onPrimary, onSecondary }) => (
    <section className="mx-auto max-w-6xl px-6 pb-20 pt-16 sm:pt-20" data-testid="events-hero">
        <div className="max-w-3xl">
            <motion.p
                initial={{ opacity: 0, y: 12 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.6, ease: EASE }}
                data-testid="events-hero-eyebrow"
                className="inline-block rounded-full border border-[#899B6A] px-4 py-1.5 text-[11px] font-medium uppercase tracking-[0.24em] text-[#4A5D23]"
            >
                Lunar event activation
            </motion.p>
            <h1
                data-testid="events-hero-heading"
                className="font-display mt-6 text-[2.9rem] font-medium leading-[1.04] tracking-tight text-[#1D201A] sm:text-7xl"
            >
                <span className="block overflow-hidden pb-1">
                    <motion.span
                        className="block"
                        initial={{ y: "112%" }}
                        animate={{ y: "0%" }}
                        transition={{ duration: 0.9, delay: 0.15, ease: EASE }}
                    >
                        We bring Lunar to <em className="italic text-[#4A5D23]">your event</em>.
                    </motion.span>
                </span>
            </h1>
            <motion.div
                initial={{ opacity: 0, y: 16 }}
                animate={{ opacity: 1, y: 0 }}
                transition={{ duration: 0.7, delay: 0.55, ease: EASE }}
            >
                <p className="mt-7 max-w-xl text-lg leading-relaxed text-[#3E413B]">
                    We help attendees find the right people in the room and start real
                    conversations.
                </p>
                <div className="mt-9 flex flex-col gap-3 sm:flex-row">
                    <button
                        data-testid="events-hero-primary-cta"
                        onClick={onPrimary}
                        className="inline-flex items-center justify-center rounded-full bg-[#2C3618] px-8 py-4 text-sm font-bold text-[#F9F8F4] transition-[background-color,transform] duration-300 hover:-translate-y-[2px] hover:bg-[#4A5D23]"
                    >
                        Plan your activation
                    </button>
                    <button
                        data-testid="events-hero-secondary-cta"
                        onClick={onSecondary}
                        className="inline-flex items-center justify-center rounded-full border border-[#2C3618] px-8 py-4 text-sm font-bold text-[#2C3618] transition-[background-color,color,transform] duration-300 hover:-translate-y-[2px] hover:bg-[#2C3618] hover:text-[#F9F8F4]"
                    >
                        See how it works
                    </button>
                </div>
                <p
                    data-testid="events-worldwide-note"
                    className="mt-4 text-[11px] font-medium uppercase tracking-[0.22em] text-[#899B6A]"
                >
                    For events worldwide
                </p>
            </motion.div>
        </div>
    </section>
);
